import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AllAreaEnum, AreaTypeEnum } from '@bo-client/activation-management/shared/models/commissioningModel';
import { Observable, Subject, map } from 'rxjs';
import { CommissioningDataService } from '@bo-client/activation-management/commissioning/forms/commissioning-data.service';
import { filter, tap } from 'rxjs/operators';
import { DataShareService } from '@bo-client/shared/services/data-share.service';
import { MetaService } from '@bo-client/core/api/meta-service';
import { GisDataEvent } from '@bo-client/shared/components/get-gis-data/get-gis-data.component';

@Component({
  selector: 'app-connection-object',
  templateUrl: './connection-object.component.html',
  styleUrls: ['./connection-object.component.scss']
})
export class ConnectionObjectComponent implements OnInit, OnDestroy {
  @Input() areaType: AreaTypeEnum;
  @Input() inputForm: FormGroup;
  @Input() disable = false;
  @Input() disableDevelopmentArea = false;
  @Output()
  gisDataEvent: EventEmitter<GisDataEvent & { availableAreas: AllAreaEnum[] }> = new EventEmitter();

  constructor(
    public commissioningDataService: CommissioningDataService,
    private metaService: MetaService,
    private dataShareService: DataShareService
  ) {}

  public objectUsages$: Observable<any>;

  private compUnsubs$ = new Subject<void>();
  noCompanyLocation$: Observable<boolean>;

  get connectionObjectForm() {
    return this.inputForm.get('connectionObject') as FormGroup;
  }

  get additionalInfoForm() {
    return this.inputForm.get('connectionObjectAdditionalInfo') as FormGroup;
  }

  get hasData() {
    return (
      this.connectionObjectForm.get('gisId').value || this.connectionObjectForm.get('corridorNumber').value
    );
  }

  ngOnInit(): void {
    // Wir wollen einen Fehler anzeigen, wenn Hausnummer oder Flurstücksnummer vorhanden sind
    // und keine Betriebsbereich ausgewählt wurde

    this.objectUsages$ = this.metaService
      .codeListValues$('objectUsage_Types', this.dataShareService.currentTenant.id)
      .pipe(filter((x) => x.length > 0));

    this.noCompanyLocation$ = this.connectionObjectForm.valueChanges.pipe(
      map((connectionObject) => {
        return (
          (connectionObject.streetNo || connectionObject.corridorNumber) && !connectionObject.orgUnitDesc
        );
      })
    );
  }

  changeObjectType() {
    this.additionalInfoForm.get('numberOfFlats').patchValue(null);
    this.additionalInfoForm.get('numberOfUsers').patchValue(null);
    this.additionalInfoForm.get('numberOfOtherUsers').patchValue(null);
    this.additionalInfoForm.get('objectUsage').patchValue(null);
  }

  ngOnDestroy() {
    this.compUnsubs$.next();
    this.compUnsubs$.complete();
  }
}
